/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { Control, UseFormClearErrors } from "react-hook-form";
import Input from "../../../components/Input";
import SelectInput from "../../../components/Select";
import {
  useFetchAllShippingPartnersData,
  useFetchAllTireData,
} from "../../../apis/zoneAndTierApis";
import { useEffect } from "react";
import { useMerchantAllListData } from "../../../apis/merchantApis";

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  reset: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  zoneItem?: any;
};
const PAYMENT_TYPE = [
  { id: 0, text: "CC", value: "CC" },
  { id: 1, text: "COD", value: "COD" },
  { id: 2, text: "BOTH", value: "BOTH" },
];
const ZoneType = [
  { id: 0, text: "System", value: "System" },
  { id: 1, text: "Client", value: "Client" },
];

const PriorityData = [
  { id: 1, text: "1", value: "1" },
  { id: 2, text: "2", value: "2" },
  { id: 3, text: "3", value: "3" },
  { id: 4, text: "4", value: "4" },
  { id: 5, text: "5", value: "5" },
  { id: 6, text: "6", value: "6" },
  { id: 7, text: "7", value: "7" },
  { id: 8, text: "8", value: "8" },
  { id: 9, text: "9", value: "9" },
  { id: 10, text: "10", value: "10" },
];

const AddZoneModal = ({
  register,
  setValue,
  watch,
  errors,
  reset,
  clearErrors,
  zoneItem = {},
}: Props) => {
  const { data: tireData } = useFetchAllTireData();
  const { data: shippingPartnersData } = useFetchAllShippingPartnersData();
  const { data: clients } = useMerchantAllListData();
  console.log(zoneItem, "z");

  useEffect(() => {
    if (zoneItem) {
      setValue("name", zoneItem?.name);
      setValue("zonetype", zoneItem?.zonetype);
      setValue("clientId", zoneItem?.clientId);
      setValue("priority", JSON.stringify(zoneItem?.priority));
      setValue("clientId", zoneItem?.clientId);
      setValue("tireId", zoneItem?.tireId);
      setValue("courierCompanyId", zoneItem?.courierCompanyId);
      setValue("paymentMode", zoneItem?.paymentMode);
      setValue("capacityPerDay", zoneItem?.capacityPerDay);
      setValue("pricePerShipment", zoneItem?.pricePerShipment);
    }
  }, [zoneItem]);

  console.log(watch(), "w");

  return (
    <div className="space-y-4">
      <div
        className={`grid  ${
          watch("zonetype") === "Client" ? "grid-cols-5" : "grid-cols-4"
        }  gap-4`}
      >
        <SelectInput
          label={"Choose Client / System"}
          selectOptions={ZoneType}
          name="zonetype"
          clearErrors={clearErrors}
          validation={{ required: "System type is required" }}
          register={register}
          value={watch("zonetype")}
          setValue={(val: string) => {
            setValue("zonetype", val);
          }}
          error={errors.zonetype}
        />
        {watch("zonetype") === "Client" && (
          <SelectInput
            label={"Select Client"}
            selectOptions={
              clients?.map((client: any) => ({
                id: client?.id,
                value: client?.id,
                text: client?.name,
              })) || []
            }
            name="clientId"
            clearErrors={clearErrors}
            validation={{ required: "client Name is required" }}
            register={register}
            value={watch("clientId")}
            setValue={(val: string) => {
              setValue("clientId", val);
            }}
            error={errors.clientId}
          />
        )}
        <Input
          name="name"
          type="text"
          title="Zone Name"
          placeholder="Enter Zone Name"
          register={register}
          error={errors.name}
          validation={{
            required: "Zone Name is required",
            pattern: {
              value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
              message:
                "Zone Name must include at least one letter (not only numbers)",
            },
            validate: (value) => {
              if (!value?.trim())
                return "Zone Name cannot be empty or only spaces";
              return true;
            },
          }}
        />
        <SelectInput
          label={"Select Tier"}
          selectOptions={
            tireData?.map((tire: any) => ({
              id: tire?.id,
              value: tire?.id,
              text: tire?.name,
            })) || []
          }
          name="tireId"
          clearErrors={clearErrors}
          validation={{ required: "Tire Name is required" }}
          register={register}
          value={watch("tireId")}
          setValue={(val: string) => {
            setValue("tireId", val);
          }}
          error={errors.tireId}
        />
        <SelectInput
          label={"Select Courier Company"}
          selectOptions={
            shippingPartnersData?.map((shippingPartners: any) => ({
              id: shippingPartners?.id,
              value: shippingPartners?.id,
              text: shippingPartners?.name,
            })) || []
          }
          name="courierCompanyId"
          clearErrors={clearErrors}
          validation={{ required: "Courier Company Name is required" }}
          register={register}
          value={watch("courierCompanyId")}
          setValue={(val: string) => {
            setValue("courierCompanyId", val);
          }}
          error={errors.courierCompanyId}
        />
      </div>
      <div className="grid grid-cols-4 gap-4">
        <SelectInput
          label={"Select Payment Mode"}
          selectOptions={PAYMENT_TYPE}
          name="paymentMode"
          clearErrors={clearErrors}
          validation={{ required: "Payment Mode  is required" }}
          register={register}
          value={watch("paymentMode")}
          setValue={(val: string) => {
            setValue("paymentMode", val);
          }}
          error={errors.paymentMode}
        />
        <Input
          name="capacityPerDay"
          type="text"
          title="Capacity"
          placeholder="Enter Capacity"
          register={register}
          error={errors.capacityPerDay}
          validation={{ required: "Capacity is required" }}
        />
        <Input
          name="pricePerShipment"
          type="text"
          title="Price Per Shipment"
          placeholder="Enter Price Per Shipment"
          register={register}
          value={watch("pricePerShipment")}
          error={errors.pricePerShipment}
          validation={{ required: "Price Per Shipment is required" }}
        />
        <SelectInput
          label={"Set Priority "}
          name="priority"
          clearErrors={clearErrors}
          validation={{ required: "Tire Name is required" }}
          register={register}
          value={watch("priority")}
          setValue={(val: string) => {
            setValue("priority", val);
          }}
          error={errors.priority}
          selectOptions={PriorityData}
        />
      </div>
    </div>
  );
};

export default AddZoneModal;
